import {
  CAMPAIGN_LANDING_FILTER_OPTIONS,
  type CampaignLandingFilter,
} from '@/features/campaigns/lib/campaign-landing-display'

import { ADMIN_DASHBOARD_LAYOUT } from '../lib/admin-dashboard-layout'
import { DashboardStatusFilter } from './DashboardStatusFilter'

interface Props {
  value: CampaignLandingFilter
  onChange: (value: CampaignLandingFilter) => void
}

/** Figma `5106:9966` — 225×42 filter field; not MUI Select (layout + chevron). */
export function RecentCampaignsStatusFilter({ value, onChange }: Readonly<Props>) {
  return (
    <DashboardStatusFilter
      value={value}
      onChange={onChange}
      options={CAMPAIGN_LANDING_FILTER_OPTIONS}
      filterWidth={ADMIN_DASHBOARD_LAYOUT.filterWidth}
      testId="admin-dashboard-campaigns-status-filter"
    />
  )
}
